import { render, staticRenderFns } from "./ChipItem.vue?vue&type=template&id=8445e65c&scoped=true&"
import script from "./ChipItem.vue?vue&type=script&lang=js&"
export * from "./ChipItem.vue?vue&type=script&lang=js&"
import style0 from "./ChipItem.vue?vue&type=style&index=0&id=8445e65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8445e65c",
  null
  
)

export default component.exports